// extracted by mini-css-extract-plugin
export default {"page":"TeacherResult_page__oxuo7","sections":"TeacherResult_sections__04tBG"};